import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, PointElement, LinearScale, CategoryScale } from 'chart.js';

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale);

const MarketCard = ({ symbol, name, price, changePercent, sparkline }) => {
  const isPositive = changePercent >= 0;

  const chartData = {
    labels: sparkline.map((_, i) => i),
    datasets: [
      {
        data: sparkline,
        borderColor: isPositive ? '#10B981' : '#EF4444',
        borderWidth: 2,
        fill: false,
        tension: 0.4,
        pointRadius: 0,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    scales: {
      x: { display: false },
      y: { display: false },
    },
  };

  return (
    <div data-testid={`market-card-${symbol}`} className="bg-white rounded-xl border border-slate-100 shadow-sm hover:shadow-md transition-all duration-200 p-5">
      <div className="flex justify-between items-start mb-3">
        <div>
          <p className="text-sm font-medium text-slate-500 uppercase tracking-wider">{symbol}</p>
          <p className="text-xs text-slate-400 mt-0.5">{name}</p>
        </div>
        <div className={`flex items-center metric-change px-2 py-1 rounded ${
          isPositive ? 'bg-emerald-50 positive-value' : 'bg-red-50 negative-value'
        }`}>
          {isPositive ? <TrendingUp className="w-3 h-3 mr-1" /> : <TrendingDown className="w-3 h-3 mr-1" />}
          <span>{Math.abs(changePercent).toFixed(2)}%</span>
        </div>
      </div>
      <p className="text-3xl font-bold text-slate-900 financial-number mb-3">${price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
      <div className="h-12">
        <Line data={chartData} options={chartOptions} />
      </div>
    </div>
  );
};

export default MarketCard;